import React, { Component } from 'react'
import { Col, Form, Modal } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from "moment";
import MultiSelect from "react-multi-select-component";
import axios from "axios";
import "./_DiaryModal.scss";
import "./_NoticeModal.scss";
import { defaultBranchValue } from "../../../utils/branchScope";

// Stream applies only to Intermediate classes (ids 15 & 16). It sits between
// Class and Section and narrows the section list by each section's stream_id.
const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const ADD_NOTICE_ASSIGNMENT_DETAILS = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
      getAcademicYears(id: $id) {
        id
        academic_year
      }
    }
  `;

class NoticeModal extends Component {
    constructor() {
        super()
        this.state = {
            branch_id: defaultBranchValue(""),
            branchError: "",
            class_id: "",
            classError: "",
            stream_id: "",
            streamError: "",
            getStreams: [],
            section_id: "",
            sectionError: "",
            getClasses: [],
            getSections: [],
            studentsOptions: [],
            selectedStudents: [],
            students_error: "",
            ldescription: "",
            ldescription_error: "",
            file_uploading: "",
            fileError: "",
            formDate: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            fromDateError: "",
            loadingSpinner: 0,
            currentStep: 1,
            dataClear: 0,
            submitError: "",
            submitted: false,
        }
    }

    // Reset the form each time the popup is opened (mirrors the Diary popup).
    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            const defBranch = defaultBranchValue("");
            this.setState({
                branch_id: defBranch,
                class_id: "",
                stream_id: "",
                section_id: "",
                getClasses: defBranch ? this.getClasses(defBranch) : [],
                getStreams: [],
                getSections: [],
                studentsOptions: [],
                selectedStudents: [],
                branchError: "",
                classError: "",
                streamError: "",
                sectionError: "",
                students_error: "",
                ldescription: "",
                ldescription_error: "",
                file_uploading: "",
                fileError: "",
                formDate: new Date().toISOString().slice(0, 10),
                currentDate: new Date().toISOString().slice(0, 10),
                fromDateError: "",
                loadingSpinner: 0,
                currentStep: 1,
                submitError: "",
                submitted: false,
                dataClear: 1,
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    // Branch/class/section come from the same services as the Diary popup:
    // getBranches → branches[].sections, getExamClasses → class labels, both
    // fetched once by the parent and passed down via stateData.
    getClasses = (branch_id) => {
        const branches = this.props.stateData.branches || [];
        const allClasses = this.props.stateData.getClasses || [];
        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        const classIds = [...new Set((branch.sections || []).map((s) => Number(s.class_id)))];
        return classIds
            .map((cid) => allClasses.find((c) => Number(c.id) === cid))
            .filter(Boolean)
            .map((c) => ({ value: c.id, label: c.class }));
    }

    getSections = (branch_id, class_id, stream_id) => {
        const branches = this.props.stateData.branches || [];
        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        return (branch.sections || [])
            .filter((s) => Number(s.class_id) === Number(class_id))
            .filter((s) => !isStreamClass(class_id) || String(s.stream_id) === String(stream_id))
            .map((s) => ({ value: s.id, label: s.section_name }));
    }

    // Distinct stream options for a branch's stream-class sections. Empty for
    // non-stream classes (Stream dropdown is hidden in that case).
    getStreamOptions = (branch_id, class_id) => {
        if (!isStreamClass(class_id)) return [];
        const branches = this.props.stateData.branches || [];
        const allStreams = this.props.stateData.allStreams || [];
        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        const streamIds = [...new Set((branch.sections || [])
            .filter((s) => Number(s.class_id) === Number(class_id) && s.stream_id)
            .map((s) => Number(s.stream_id)))];
        return streamIds.map((id) => ({
            value: id,
            label: (allStreams.find((st) => Number(st.id) === Number(id))?.stream) || `Stream ${id}`,
        }));
    }

    // Students for the chosen branch/section (notice-specific field). Section ids are
    // unique, so branch + section is enough to scope students to the selection.
    getStudentOptions = (branch_id, section_id) => {
        const students = this.props.getStudents || [];
        return students
            .filter((s) =>
                String(s.branch_id) === String(branch_id) &&
                String(s.section_id) === String(section_id)
            )
            .map((s) => ({ value: s.student_id, label: `${s.roll_no} => ${s.student_name}` }));
    }

    // Single-select cascade for branch → class → section → students.
    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name === "branch") {
            this.setState({
                branch_id: value,
                class_id: "",
                stream_id: "",
                section_id: "",
                getClasses: value ? this.getClasses(value) : [],
                getStreams: [],
                getSections: [],
                studentsOptions: [],
                selectedStudents: [],
                branchError: "",
                classError: "",
                streamError: "",
                sectionError: "",
                students_error: "",
            });
        }

        if (name === "class") {
            // Stream classes load no sections until a stream is picked; other
            // classes load their sections immediately.
            this.setState({
                class_id: value,
                stream_id: "",
                section_id: "",
                getStreams: value ? this.getStreamOptions(this.state.branch_id, value) : [],
                getSections: value ? this.getSections(this.state.branch_id, value, "") : [],
                studentsOptions: [],
                selectedStudents: [],
                classError: "",
                streamError: "",
                sectionError: "",
                students_error: "",
            });
        }

        if (name === "stream") {
            this.setState({
                stream_id: value,
                section_id: "",
                getSections: this.getSections(this.state.branch_id, this.state.class_id, value),
                studentsOptions: [],
                selectedStudents: [],
                streamError: "",
                sectionError: "",
                students_error: "",
            });
        }

        if (name === "section") {
            const studentsOptions = value
                ? this.getStudentOptions(this.state.branch_id, value)
                : [];
            this.setState({
                section_id: value,
                studentsOptions,
                selectedStudents: studentsOptions, // default: all students selected
                sectionError: "",
                students_error: "",
            });
        }
    }

    handleStudentChange = (e) => {
        const selectedStudents = (e || []).map((s) => ({ label: s.label, value: s.value }));
        this.setState({ selectedStudents, students_error: "" });
    }

    selecthandleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "file_uploading") {
            const file = e.target.files[0];
            if (!file) return;

            // File type validation
            if (file.type !== "application/pdf" && !file.name.toLowerCase().endsWith(".pdf")) {
                this.setState({ fileError: "Only PDF files are allowed.", file_uploading: "" });
                return;
            }

            // File size validation (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.setState({ fileError: "File size exceeds 5MB limit.", file_uploading: "" });
                return;
            }

            this.setState({ fileError: "" });
            const formData = new FormData();
            formData.append('file', file);
            axios.post('https://rizee.in/pdfFiles.php?dairyAssignmentFiles=true', formData)
                .then((response) => {
                    this.setState({ file_uploading: response.data.filename });
                })
                .catch(() => {
                    this.setState({ fileError: 'An error occurred while uploading the file.' });
                });
            return;
        }

        if (name == "ldescription") this.setState({ ldescription_error: "" });
        this.setState({ [name]: value });
    }

    selDate = (e) => {
        this.setState({ formDate: e.target.value })
    }

    handleFormSubmit = () => {
        if (!this.state.branch_id) {
            this.setState({ branchError: "Please select branch" });
            return;
        }
        if (!this.state.class_id) {
            this.setState({ classError: "Please select class" });
            return;
        }
        if (isStreamClass(this.state.class_id) && !this.state.stream_id) {
            this.setState({ streamError: "Please select stream" });
            return;
        }
        if (!this.state.section_id) {
            this.setState({ sectionError: "Please select section" });
            return;
        }
        if (!this.state.selectedStudents.length) {
            this.setState({ students_error: "Please select at least one student" });
            return;
        }
        if (!this.state.ldescription || this.state.ldescription.trim() === "") {
            this.setState({ ldescription_error: "Please enter description" });
            return;
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            description: this.state.ldescription,
            dairy_assignment_type_id: parseInt(2),
            from_date: moment(this.state.formDate, 'YYYY-MM-DD').unix().toString(),
            file_path: this.state.file_uploading == "" || this.state.file_uploading == undefined
                ? ""
                : `https://rizee.in/educational_mngt/dairy_assignment_files/${this.state.file_uploading}`,
            branch_id: parseInt(this.state.branch_id),
            class_id: this.state.class_id.toString(),
            section_ids: this.state.section_id.toString(),
            inserted_by: parseInt(Cookies.get("id")),
            student_ids: this.state.selectedStudents.map((item) => item.value).toString(),
            employee_id: 0,
        }

        this.setState({ loadingSpinner: 1, submitError: "" })
        this.addDairyAssignmentDetails(params).catch(error => {
            const submitError = this.getErrorMessage(error);
            this.setState({ submitError, loadingSpinner: 0 });
        })
    };

    getErrorMessage = (error) => {
        if (!error) return "Something went wrong while sending the notice.";
        if (Array.isArray(error.graphQLErrors) && error.graphQLErrors.length > 0) {
            return error.graphQLErrors.map((x) => x.message).join(", ");
        }
        if (error.networkError && error.networkError.result && Array.isArray(error.networkError.result.errors)) {
            return error.networkError.result.errors.map((x) => x.message).join(", ");
        }
        if (error.message) return error.message;
        try {
            return JSON.stringify(error);
        } catch (e) {
            return "An unexpected error occurred.";
        }
    }

    addDairyAssignmentDetails = async params => {
        await this.props.addDairyAssignmentDetails({
            variables: { params },
            update: (store, { data }) => {
                if (data.addDairyAssignmentDetails) {
                    this.setState({ loadingSpinner: 0, currentStep: 5 });
                    setTimeout(() => {
                        if (this.props.onSubmitSuccess) {
                            this.props.onSubmitSuccess();
                        } else {
                            this.props.onHide();
                        }
                    }, 1500);
                }
            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    render() {
        const branches = this.props.stateData.branches || [];
        const studentselectall = this.state.studentsOptions.length > 0;

        return (
            <Modal {...this.props} size="lg" aria-labelledby="notice-modal-title">
                {/* ── Header ── */}
                <Modal.Header closeButton className="dm-modal-header">
                    <div className="dm-header-icon"><i className="fal fa-bullhorn" /></div>
                    <div className="dm-header-info">
                        <p className="dm-title">Add Notice</p>
                        <p className="dm-subtitle">Send a notice to selected students</p>
                    </div>
                </Modal.Header>

                {/* ── Body ── */}
                <Modal.Body className="p-4">

                    {/* Date bar */}
                    <div className="dm-date-bar">
                        <span className="dm-date-label">
                            <i className="fas fa-calendar-alt" /> Notice Date
                        </span>
                        <input
                            type="date"
                            name="formDate"
                            min={moment().subtract(3, 'days').format('YYYY-MM-DD')}
                            max={this.state.currentDate}
                            value={this.state.formDate}
                            onChange={this.selDate}
                        />
                    </div>

                    <Form>
                        <Form.Row>
                            {/* Branch */}
                            <Form.Group as={Col} lg={4} md={6} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-code-branch" /> Branch
                                    </label>
                                    <select
                                        className={`dm-select form-control${this.state.branchError ? " is-err" : ""}`}
                                        name="branch"
                                        onChange={this.handleInputChange}
                                        value={this.state.branch_id}
                                    >
                                        <option value="">Select Branch</option>
                                        {branches.map(b => (
                                            <option key={b.id} value={b.id}>{b.branch_name}</option>
                                        ))}
                                    </select>
                                    {this.state.branchError && (
                                        <div className="dm-field-err">
                                            <i className="fas fa-exclamation-circle" />{this.state.branchError}
                                        </div>
                                    )}
                                </div>
                            </Form.Group>

                            {/* Class */}
                            <Form.Group as={Col} lg={4} md={6} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-chalkboard" /> Class
                                    </label>
                                    <select
                                        className={`dm-select form-control${this.state.classError ? " is-err" : ""}`}
                                        name="class"
                                        onChange={this.handleInputChange}
                                        value={this.state.class_id}
                                    >
                                        <option value="">Select Class</option>
                                        {this.state.getClasses.map(c => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </select>
                                    {this.state.classError && (
                                        <div className="dm-field-err">
                                            <i className="fas fa-exclamation-circle" />{this.state.classError}
                                        </div>
                                    )}
                                </div>
                            </Form.Group>

                            {/* Stream (Intermediate classes only) */}
                            {isStreamClass(this.state.class_id) && (
                                <Form.Group as={Col} lg={4} md={6} sm={12}>
                                    <div className="dm-field">
                                        <label className="dm-label">
                                            <i className="fas fa-stream" /> Stream
                                        </label>
                                        <select
                                            className={`dm-select form-control${this.state.streamError ? " is-err" : ""}`}
                                            name="stream"
                                            onChange={this.handleInputChange}
                                            value={this.state.stream_id}
                                        >
                                            <option value="">Select Stream</option>
                                            {this.state.getStreams.map(st => (
                                                <option key={st.value} value={st.value}>{st.label}</option>
                                            ))}
                                        </select>
                                        {this.state.streamError && (
                                            <div className="dm-field-err">
                                                <i className="fas fa-exclamation-circle" />{this.state.streamError}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            )}

                            {/* Section */}
                            <Form.Group as={Col} lg={4} md={6} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-layer-group" /> Section
                                    </label>
                                    <select
                                        className={`dm-select form-control${this.state.sectionError ? " is-err" : ""}`}
                                        name="section"
                                        onChange={this.handleInputChange}
                                        value={this.state.section_id}
                                        disabled={isStreamClass(this.state.class_id) && !this.state.stream_id}
                                    >
                                        <option value="">Select Section</option>
                                        {this.state.getSections.map(s => (
                                            <option key={s.value} value={s.value}>{s.label}</option>
                                        ))}
                                    </select>
                                    {this.state.sectionError && (
                                        <div className="dm-field-err">
                                            <i className="fas fa-exclamation-circle" />{this.state.sectionError}
                                        </div>
                                    )}
                                </div>
                            </Form.Group>

                            {/* Students */}
                            <Form.Group as={Col} lg={4} md={6} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-users" /> Students
                                    </label>
                                    <div className={`nm-multiselect${this.state.students_error ? " is-err" : ""}`}>
                                        <MultiSelect
                                            overrideStrings={{ allItemsAreSelected: "All Students selected", selectSomeItems: "Select Students" }}
                                            disableSearch={!studentselectall}
                                            hasSelectAll={studentselectall}
                                            options={this.state.studentsOptions}
                                            value={this.state.selectedStudents}
                                            onChange={this.handleStudentChange}
                                            labelledBy="student"
                                        />
                                    </div>
                                    {this.state.students_error && (
                                        <div className="dm-field-err">
                                            <i className="fas fa-exclamation-circle" />{this.state.students_error}
                                        </div>
                                    )}
                                </div>
                            </Form.Group>

                            {/* Description */}
                            <Form.Group as={Col} lg={8} md={6} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-pen-alt" /> Description
                                    </label>
                                    <textarea
                                        className={`dm-textarea${this.state.ldescription_error ? " is-err" : ""}`}
                                        name="ldescription"
                                        value={this.state.ldescription}
                                        onChange={this.selecthandleInputChange}
                                        placeholder="Write your notice here..."
                                    />
                                    {this.state.ldescription_error && (
                                        <div className="dm-field-err">
                                            <i className="fas fa-exclamation-circle" />{this.state.ldescription_error}
                                        </div>
                                    )}
                                </div>
                            </Form.Group>

                            {/* File Upload */}
                            <Form.Group as={Col} lg={12} md={12} sm={12}>
                                <div className="dm-field">
                                    <label className="dm-label">
                                        <i className="fas fa-file-pdf" /> Attach PDF{" "}
                                        <span style={{ textTransform: "none", fontWeight: 400, color: "#94a3b8" }}>(optional)</span>
                                    </label>
                                    <div style={{ position: "relative" }}>
                                        <div className="nm-upload-zone">
                                            <div className="nm-upload-icon">
                                                <i className="fas fa-cloud-upload-alt" />
                                            </div>
                                            <div className="nm-upload-text">Click to upload PDF</div>
                                            <div className="nm-upload-hint">Only .pdf files supported</div>
                                            <input
                                                type="file"
                                                name="file_uploading"
                                                accept=".pdf"
                                                onChange={(e) => this.selecthandleInputChange(e)}
                                                style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer" }}
                                            />
                                        </div>
                                        {this.state.file_uploading && (
                                            <div className="nm-upload-success">
                                                <i className="fas fa-check-circle" /> {this.state.file_uploading}
                                            </div>
                                        )}
                                        {this.state.fileError && (
                                            <div className="dm-field-err">
                                                <i className="fas fa-exclamation-circle" />{this.state.fileError}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Form.Group>
                        </Form.Row>

                        {/* Feedback banners */}
                        {this.state.currentStep == 5 && (
                            <div className="dm-banner success">
                                <i className="fas fa-check-circle" />
                                Notice sent successfully!
                            </div>
                        )}
                        {this.state.submitError && this.state.currentStep != 5 && (
                            <div className="dm-banner error">
                                <i className="fas fa-times-circle" />
                                {this.state.submitError}
                            </div>
                        )}
                    </Form>
                </Modal.Body>

                {/* ── Footer ── */}
                <div className="dm-footer">
                    <button className="dm-btn-cancel" onClick={this.SetpageLoad}>
                        Cancel
                    </button>
                    <button
                        className="dm-btn-submit"
                        onClick={this.handleFormSubmit}
                        disabled={this.state.loadingSpinner == 1 || this.state.currentStep == 5}
                    >
                        {this.state.loadingSpinner == 1 && (
                            <span className="spinner-border spinner-border-sm" />
                        )}
                        Send Notice
                    </button>
                </div>
            </Modal>
        )
    }
}

export default withRouter(compose(
    graphql(ADD_NOTICE_ASSIGNMENT_DETAILS, {
        name: "addDairyAssignmentDetails"
    }),
    graphql(GET_ACADEMIC_YEARS, {
        name: "getAcademicYearsQuery",
        options: {
            variables: { id: 1 },
        },
        fetchPolicy: "network-only"
    })
)(NoticeModal));
